/**
 * CODE
 */

/**
 * I am a generic application error.
 */
class ApplicationError extends Error
{
    /**
     * I initialize myself.
     *
     * :param message: error message
     *
     * :returns: nothing
     */
    constructor (message: string)
    {
        // call the superclass constructor
        super(message);

        // restore the subclass prototype, lost by the es5 Error subclassing
        Object.setPrototypeOf(this, new.target.prototype);

        // set exception name
        this.name = this.constructor.name;
    }
}


/**
 * EXPORTS
 */
export {
    ApplicationError,
};
